/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

var day_names = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

module.exports = Model({
	name: "managedremindermaker",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_reminders: null
});

function init() {
	this._reminders = [];
	this._who = null;

	this.push({
		editing: false,
		creating: false
	});
}

function uninit() {
	this._who = null;
	this._reminders = null;
}

function listeners() {
	return {
		"managedreminders:updated": handle_reminders_updated,
		"managedreminders:viewing": handle_reminders_viewing
	};
}

function triggers() {
	return {
		"add:start": start_add,
		"add:finish": finish_add,
		"edit:start": start_edit,
		"edit:finish": finish_edit
	};
}

function start_add() {
	this.extend({
		editing: false,
		creating: true
	});
	this.dispatch("open");
	this.emit("usermetrics:trigger:track", "begin creating reminder for managed user", {
		who: this._who,
	});
}

function finish_add(data) {
	var schedule = calculate_cron(data);
	var content = data.content;
	var message = null;

	if (!content || !schedule) {
		message = "remindermaker.error";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to create reminder for managed user but did not fill all fields");
		return;
	}

	var notification = data.notification;
	var responseType = data.responseType;

	this.emit("managedreminders:trigger:add", {
		content: content,
		schedule: schedule,
		notification: notification,
		responseType: responseType
	});
	this.dispatch("close");
	message = "remindermaker.saved";
	this.emit("toast:trigger:show", {
		content: message
	});
}

function start_edit(data) {
	var reminder = data.reminder;

	var reminderData = this._reminders.reduce(function (found, item) {
		if (found) return found;
		if (item._id === reminder) return item;
		return null;
	}, null);

	var scheduleData = model_from_cron(reminderData.schedule);

	var editData = xtend(reminderData, scheduleData);

	this.extend({
		editing: editData,
		creating: false
	});
	this.dispatch("open");

	this.emit("usermetrics:trigger:track", "begin editing reminder for managed user", {
		who: this._who,
	});
}

function finish_edit(data) {
	var schedule = calculate_cron(data);
	var content = data.content;
	var notification = data.notification;
	var responseType = data.responseType;

	var reminder = this.data.editing._id;

	this.emit("managedreminders:trigger:edit", {
		reminder: reminder,
		content: content,
		schedule: schedule,
		notification: notification,
		responseType: responseType
	});
	this.dispatch("close");
	var message = "remindermaker.saved";
	this.emit("toast:trigger:show", {
		content: message
	});

	this.emit("usermetrics:trigger:track", "edited reminder for managed user", {
		who: this._who,
	});
}

function calculate_cron(data) {
	var minutes = parseInt(data.time.minutes, 10) || 0;
	var hours = parseInt(data.time.hours, 10) || 0;
	var repeat = parseInt(data.repeat, 10) || 0;

	var date = new Date(data.months);
	var scheduleMonth = data.monthSwitch;

	var day = "*";
	var month = "*";

	var days = "*";
	var day_list = data.days;
	var all_days = day_list.all || scheduleMonth;
	if (!all_days) days = day_names.reduce(function (result, day_name) {
		if (day_list[day_name]) return result.concat(day_name.toUpperCase());
		return result;
	}, []).join(",") || "*";

	if (scheduleMonth) {
		day = date.getUTCDate();
		month = date.getUTCMonth();
	}

	if (repeat && !scheduleMonth) repeat = "-23/" + repeat;

	return [minutes, hours + repeat, day, month, days].join(" ");
}

function model_from_cron(cron) {
	var data = {};

	var parts = cron.split(" ");
	var minutes = parts[0];
	var hours = parts[1];
	var day = parts[2];
	var month = parts[3];
	var days = parts[4];
	var repeat = 0;

	if (hours.indexOf("-") >= 0) {
		var splitHours = hours.split("-");
		hours = splitHours[0];
		repeat = parseInt(splitHours[1].slice(-1), 10) || 0;
	}

	var allDays = days === "*";
	var dayData = day_names.reduce(function (result, dayName) {
		var upperName = dayName.toUpperCase();
		var isInCron = days.indexOf(upperName) !== -1;
		var dayValue = allDays || isInCron;
		result[dayName] = dayValue;
		return result;
	}, {
		all: allDays
	});

	var monthValue = 0;
	var dayInMonthValue = 0;

	if (month !== "*") monthValue = month;

	if (day !== "*") dayInMonthValue = day;

	var date = new Date(new Date().getFullYear(), monthValue, dayInMonthValue);

	data.time = {
		minutes: minutes,
		hours: hours
	};
	data.repeat = repeat;
	data.days = dayData;

	if (monthValue !== 0 || dayInMonthValue !== 0) {
		data.months = date.toJSON();
		data.monthSwitch = true;
	}

	return data;
}

function handle_reminders_updated(reminders) {
	this._reminders = reminders.list;
}

function handle_reminders_viewing(data) {
	this._who = data?.who
}

